import React from 'react';
import { Task } from '../types';

type Props = {
  tasks: Task[];
  onCreate: () => void;
  onEdit: (t: Task) => void;
  onDelete: (id: string) => void;
  getStatusColor: (status: string) => string;
  getPriorityColor: (priority: string) => string;
};

export default function TasksSection({ tasks, onCreate, onEdit, onDelete, getStatusColor, getPriorityColor }: Props) {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-lg font-semibold text-gray-900">Tarefas do Projeto</h3>
        <button onClick={onCreate} className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700"><i className="ri-add-line mr-2"></i>Nova Tarefa</button>
      </div>
      <div className="space-y-4">
        {tasks.map((task) => (
          <div key={task.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-sm">
            <div className="flex justify-between items-start mb-3">
              <h4 className="font-medium text-gray-900">{task.title}</h4>
              <div className="flex space-x-2">
                <button onClick={() => onEdit(task)} className="text-gray-400 hover:text-gray-600"><i className="ri-edit-line"></i></button>
                <button onClick={() => onDelete(task.id)} className="text-gray-400 hover:text-red-600"><i className="ri-delete-bin-line"></i></button>
              </div>
            </div>
            <p className="text-gray-600 text-sm mb-3">{task.description}</p>
            <div className="flex flex-wrap gap-2 mb-3">
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(task.status)}`}>{task.status}</span>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${getPriorityColor(task.priority)}`}>{task.priority}</span>
            </div>
            <div className="flex justify-between items-center text-sm text-gray-600">
              <span>Responsável: {task.assignee || 'N/A'}</span>
              <span>Prazo: {task.due_date ? new Date(task.due_date).toLocaleDateString('pt-BR') : 'N/A'}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}